import $ from 'jquery'
import IdentifyQuery from './identify/Query'
import Popup from './ui/Popup'
import { getSelectStyleFunction } from './ol'
import Spinner from './ui/Spinner'
import { parseStyle } from './styleParser'
import MapBrowserEvent from 'ol/MapBrowserEvent'
import Collection from 'ol/Collection'

import FeatureSelection from './ol/FeatureSelection.js'

/**
 * Selection/identify logic
 *
 * Automatically disabled when map interactive tools is active.
 *
 * @param {Object} config OLGA Configuration object
 * @constructor
 */
export default function AutoSelection(config) {
  $.extend(this, config)

  this.active = false

  this.map.getInteractions().on('add', this.onInteractionsChange.bind(this))
  this.map.getInteractions().on('remove', this.onInteractionsChange.bind(this))

  this.featureSelection = new FeatureSelection({
    map: this.map,
    style: this.selectionStyle
      ? parseStyle(this.selectionStyle)
      : getSelectStyleFunction()
  })

  this.popup = new Popup({
    options: this.config.popup,
    map: this.map,
    autoSelection: this,
    actionCallback: this.popupActionCallback.bind(this)
  })

  this.spinner = new Spinner({
    color: ['#009fdf', '#46B7E4', '#7ED1F3', '#A5D9EF', '#C7E0EA']
  })

  this.coordinate = null
  this.map.on('click', this.handleClick.bind(this))

  this.identifyQuery = new IdentifyQuery({
    map: this.map,
    layers: this.layers,
    api: this.api
  })

  this.popupActionCallbacks = []

  this.conditionalToggle()
}
/**
 * Convert click event to query options object
 * @param {MapBrowserEvent} e
 * @return {Object}
 */
AutoSelection.prototype.queryOptionsFromClickEvent = function(e) {
  const [pixelX, pixelY] = e.pixel
  const padding = 5
  const leftCorner = this.map.getCoordinateFromPixel([
    pixelX - padding,
    pixelY - padding
  ])
  const rightCorner = this.map.getCoordinateFromPixel([
    pixelX + padding,
    pixelY + padding
  ])
  const paddedExtent = [
    Math.min(leftCorner[0], rightCorner[0]),
    Math.min(leftCorner[1], rightCorner[1]),
    Math.max(leftCorner[0], rightCorner[0]),
    Math.max(leftCorner[1], rightCorner[1])
  ]

  return {
    pixel: e.pixel,
    coordinate: e.coordinate,
    extent: paddedExtent,
    padding: padding
  }
}

/**
 * Handle map click events
 * @param {MapBrowserEvent} e
 */
AutoSelection.prototype.handleClick = function(e) {
  this.conditionalToggle()

  if (!this.active) {
    return
  }

  this.coordinate = e.coordinate
  this.spinner.start()
  this.identifyQuery
    .query(this.queryOptionsFromClickEvent(e), this.map)
    .then(features => {
      this.spinner.stop()
      if (features.length) {
        this.showPopup(features, e.coordinate)
      } else {
        this.popup.destroy()
        this.featureSelection.clearFeatures()
      }
    })
    .catch(err => {
      this.spinner.stop()
      console.error(err)
    })
}

/**
 * Current selected features
 *
 * Can be observed for changes or used to add or remove selected features programmatically.
 * See [Collection](https://openlayers.org/en/v6.3.1/apidoc/module-ol_Collection-Collection.html) for details.
 * @type {Collection}
 */
AutoSelection.prototype.features = null

/**
 * Activate select and identify
 */
AutoSelection.prototype.activate = function() {
  if (!this.active) {
    this.featureSelection.activate()
    this.active = true
  }
}

/**
 * Deactivate select and identify
 */
AutoSelection.prototype.deactivate = function() {
  if (this.active) {
    this.popup.destroy()
    this.featureSelection.clearFeatures()
    this.featureSelection.deactivate()
    this.active = false
  }
}

/**
 * Activate if no other interaction tool is active
 */
AutoSelection.prototype.conditionalToggle = function() {
  if (!this.toolbar.activeTool) {
    this.activate()
  } else {
    this.deactivate()
  }
}

/**
 * @param {Object} e
 */
AutoSelection.prototype.onInteractionsChange = function(e) {
  setTimeout(() => {
    if (!this.conditionalToggle) {
      console.log('not exist 222', this)
    }
    if (e.element !== this.select && this.conditionalToggle) {
      this.conditionalToggle()
    }
  }, 5000)
}

/**
 * @param {Object} features
 * @param {Object} identify
 */
AutoSelection.prototype.showPopup = function(features, coordinate) {
  this.popup.show(features, coordinate || this.coordinate)
}

/**
 * Popup action callback
 * @param {Object} properties
 */
AutoSelection.prototype.popupActionCallback = function(properties) {
  console.info(
    this.popupActionCallbacks.length +
      ' registred popup action callbacks found.'
  )
  this.popupActionCallbacks.forEach(callback => callback(properties))
}

/**
 * Add popup action callback
 * @api
 * @param {function} callback Will be called when user clicks the action icon in popup with the properties as first argument
 */
AutoSelection.prototype.popupActionCallbackAdd = function(callback) {
  this.popupActionCallbacks.push(callback)
}
